import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-with-us',
  templateUrl: './share-with-us.component.html',
  styleUrls: ['./share-with-us.component.scss']
})
export class ShareWithUsComponent implements OnInit {
  @Input() title?: string = "";
  @Input() facebook? = {photo:'',description:'',title:''};
  constructor() { }

  ngOnInit(): void {
  }
printPage(){
  window.print();
}
copyUrl(){
  copyToClipboard(window.location.href);
  
}
}


export function copyToClipboard(text: string): void {
const input = document.createElement('textarea');
input.value = text;
document.body.appendChild(input);
input.select();
document.execCommand('copy');
document.body.removeChild(input);
}